import { TypedUseSelectorHook, useSelector } from 'react-redux';

import { ApplicationState } from 'types/store';

export const useAppSelector: TypedUseSelectorHook<ApplicationState> = useSelector;
